import React, { useCallback, useState } from 'react';
import { Currency } from '../../../../../../ui-toolkit';
import { useGetEmdAmount } from './hooks/useGetEmdAmount';
import _ from 'lodash';
import { NoEmdFee } from './NoEmdFee';
import { SimpleModalTW } from '../../../../../../tailwindComponents/modals/SimpleModalTW';
import { CreateEmdPasscode } from './CreateEmdPasscode';
import { AcornAccessCodeDisplayAndButtons } from './AcornAccessCodeDisplayAndButtons';

export const EmdDisplayAndAcornPasscodeGenerator: React.FC = () => {
  const { emdAmount } = useGetEmdAmount();
  const [showModal, setShowModal] = useState<boolean>(false);

  const onClick = useCallback(() => {
    setShowModal(true);
  }, [setShowModal]);

  const onClose = useCallback(() => {
    setShowModal(false);
  }, [setShowModal]);

  if (_.isNil(emdAmount)) {
    return <NoEmdFee />;
  }

  return (
    <div className={'flex flex-col items-start gap-2 py-2'}>
      <SimpleModalTW
        open={showModal}
        setOpen={setShowModal}
        titleNode={<div className={'text-lg font-bold'}>Send Access Email</div>}
      >
        <CreateEmdPasscode onClose={onClose} />
      </SimpleModalTW>
      <Currency data-test-id={'emd-amount'} value={emdAmount} />
      <AcornAccessCodeDisplayAndButtons onClick={onClick} />
    </div>
  );
};
